import { render } from "./extra-services.vue?vue&type=template&id=43f1f014"
import script from "./extra-services.vue?vue&type=script&lang=js"
export * from "./extra-services.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__